/**
 * Skeleton Loader
 * Toggle skeleton loading state on result cards
 */

import { elements } from '../core/elements.js';

/**
 * Toggle skeleton loader class on camp cards
 * @param {boolean} show - Whether to show or hide skeleton
 */
export function toggleSkeleton(show) {
  const elemsToToggle = Array.from(
    elements.resultsContainer.querySelectorAll(
      ".rd-camp-card__image, .rd-camp-card__title, .rd-camp-card__sport, .rd-camp-card__tag, .rd-camp-card__availability>*, .rd-camp-card__location, .rd-camp-card__distance, .rd-camp-card__sessions-empty, .rd-camp-card__session, .rd-camp-card__sessions-more, .rd-camp-card__footer-cta"
    )
  );
  if (!!elemsToToggle.length) {
    if (show) {
      elemsToToggle.forEach((item) => {
        item.classList.add('rd-skeleton');
        if (item.classList.contains('rd-camp-card__image')) {
          item.classList.remove('loaded');
        }
      });
    } else {
      elemsToToggle.forEach((item) => {
        !item.classList.contains('rd-camp-card__image') &&
          item.classList.remove('rd-skeleton');
      });
    }
  }
}

console.log('📦 Skeleton module loaded');
